/*============ Create Account Controller
 ================================*/
 angular
 .module('vppApp')
 .controller('createAccountController', createAccountController);

createAccountController.$inject = ['$scope', '$rootScope', 'vppConfig', 'dobFilter', 'apiFactory', '$state', '$http', 'AuthenticationService', 'CreateAccountService', 'ModuleService', 'DTMTrackerService', 'ThirdPartyMessages', '$cookies', '$window'];

function createAccountController($scope, $rootScope, vppConfig, dobFilter, apiFactory, $state, $http, AuthenticationService, CreateAccountService, ModuleService, DTMTrackerService, ThirdPartyMessages, $cookies, $window) {
 var service = {};



 // false for ded
 // true to everything else
 if (!$cookies.get('createAccountDirect')){
   $rootScope.siteCode === 'ded' ? $state.go('index') : $state.go('sign-in-notice');
 }


 var _createAccountFor = vppConfig.folderPath;
 $scope.siteName = vppConfig.siteNames[vppConfig.folderPath];
 $scope.siteNumber = vppConfig.phoneNumbers[vppConfig.folderPath];
 $scope.isFRD = vppConfig.folderPath === "frd" ? true : false;  //TODO: remove it
 $scope.isIAM = $scope.siteCode !== 'ded' ? true : false;
 $scope.isEMP = vppConfig.folderPath === "emp" ? true : false;
 $scope.securityQuestions = CreateAccountService.getSecurityQuestions();
 $scope.userFirstName = CreateAccountService.userFirstName;
 $scope.userLastName = CreateAccountService.userLastName;
 $scope.userEmailAddress = CreateAccountService.userEmailAddress;
 DTMTrackerService.updatePageLoadData('pageName', $state.current.name);
 $scope.subsidiary = {
   selectedSubsidiary: null
 };

 $scope.signedIn = false;
 $scope.onStarLock = false;

 $scope.nicknameFirstNameRequired = false;
 $scope.nicknameLastNameRequired = false;
 $scope.userAccountMigrationDetails = {};

 $scope.errorRequired = {
   required: true
 }

 $scope.user = {
   accountDetails: {
     city: "",
     dateOfBirth: "",
     firstName: "",
     lastName: "",
     phoneNumber: "",
     postalCode: "",
     stateInclPR: "",
     streetAddress: "",
     cellNumber: "",
     nicknameFirstName: "",
     nicknameLastName: ""
   },
   email: ""
 };
 $scope.positionDropdown = {};
 $scope.frdPosition;

 $scope.nicknameSelection = "default";

 $scope.setCreateAccountUserState = function () {

   if ($rootScope.cookie && $rootScope.cookie.signedIn) {
     $rootScope.createAnAccountUserType = "activeSessionExistingUser";

   } else if (!$rootScope.cookie && $rootScope.hasIamAccount) {
     $rootScope.createAnAccountUserType = "noActiveSessionExistingUser";

   } else {
     $rootScope.createAnAccountUserType = "newUser";

   }
 }

 if ($cookies.get("Registration") && $scope.isIAM) {
   apiFactory.readRegistrationCookie().then(function success(response) {

     if (response.data.signedIn) {
       $scope.user.email = response.data.email || $scope.user.email;
       $scope.email = response.data.email || $scope.email;
       $scope.user.accountDetails.city = response.data.city || $scope.user.accountDetails.city;
       $scope.user.accountDetails.firstName = response.data.firstName || $scope.user.accountDetails.firstName;
       $scope.user.accountDetails.lastName = response.data.lastName || $scope.user.accountDetails.lastName;
       $scope.user.accountDetails.phoneNumber = response.data.phoneNumber || $scope.user.accountDetails.phoneNumber;
       $scope.user.accountDetails.postalCode = response.data.postalCode || $scope.user.accountDetails.postalCode;
       $scope.user.accountDetails.stateInclPR = response.data.state || $scope.user.accountDetails.stateInclPR;
       $scope.user.accountDetails.streetAddress = response.data.streetAddress || $scope.user.accountDetails.streetAddress;
       $rootScope.cookie = response.data || $rootScope.cookie;
     }

     $scope.setCreateAccountUserState();

   });
 } else {
   $scope.setCreateAccountUserState();
 }

 if ($rootScope.fromState.name !== "create-account.step-2" && $state.current.name === "create-account") {
   CreateAccountService.resetAccountData();
 }

 $scope.userAccountMigrationDetails = CreateAccountService.getAccountMigrationUserInput();

 if ($scope.userAccountMigrationDetails) {
   $scope.user.email = $scope.userAccountMigrationDetails.email;
 }


 var savedData = CreateAccountService.getAccountDetails();

 if (savedData.accountDetails) {
   $scope.user.accountDetails.city = savedData.accountDetails.city;
   $scope.user.accountDetails.dateOfBirth = ($rootScope.fromState.name === "create-account.step-2" && $state.current.name === "create-account") ? savedData.accountDetails.dateOfBirth.replace(/\//g, '') : savedData.accountDetails.dateOfBirth;
   $scope.user.accountDetails.firstName = savedData.accountDetails.firstName;
   $scope.user.accountDetails.lastName = savedData.accountDetails.lastName;
   $scope.user.accountDetails.phoneNumber = savedData.accountDetails.phoneNumber;
   $scope.user.accountDetails.postalCode = savedData.accountDetails.postalCode;
   $scope.user.accountDetails.stateInclPR = savedData.accountDetails.stateInclPR;
   $scope.user.accountDetails.streetAddress = savedData.accountDetails.streetAddress;
   $scope.user.accountDetails.cellNumber = savedData.accountDetails.cellNumber;
   $scope.user.accountDetails.uscaPostalCode = savedData.accountDetails.uscaPostalCode;
   $scope.user.email = savedData.email;
 }

 if ($rootScope.siteCode === 'emp' && $rootScope.cookie && $rootScope.cookie.onStarFieldLock) {
   $scope.user.accountDetails.nicknameFirstName = $rootScope.cookie.nicknameFirstName;
   $scope.user.accountDetails.nicknameLastName = $rootScope.cookie.nicknameLastName;
 }

 if ($state.current.name === "create-account") {
   CreateAccountService.setCreateAccountStep("step1");
 }

 if (CreateAccountService.getCreateAccountStep() === "step2") {
   $scope.skipNameValidation = true;
 }
 // Refresh Check - If user is on Step2-3, refresh, Data is lost, return to step 1
 if (CreateAccountService.getCreateAccountStep() === "step1" && $state.current.name !== "create-account") {
   $state.go("create-account");
 }
 // get /registration Details - Process needed with create - account Service for later use
 if (CreateAccountService.getCreateAccountStep() === "step1") {

   if ($scope.siteCode === 'frd') {
     $scope.positionDropdown = vppConfig.registrationDetails.frd;
   }

   apiFactory.userRegistrationDetails()
     .then(function successSignIn(response) {
       ModuleService.setModuleDetails(response.data, _createAccountFor);
       CreateAccountService.setSecurityQuestions(response.data.securityQuestions);
       $scope.securityQuestions = response.data.securityQuestions;
     }, function errorCallback(response) {
       $scope.serverError = response.data.errors;
     });
 }


 if ($state.current.name === "create-account.step-3") {
   switch (_createAccountFor) {
     case "mpp":
       var _tempStep3Obj = ModuleService.getModuleDetailsMPPServiceBranch();
       $scope.serviceBranch = ModuleService.getModuleDetailsMPPServiceBranch();
       $scope.mppStatus = ModuleService.getModuleDetailsMPPStatus();
       break;
     case "gmed":
       $scope.gmedPosition = ModuleService.getModuleDetailsGMEDPosition();
       $scope.gmedSchoolType = ModuleService.getModuleDetailsGMEDSchoolType();
       break;
     case "cgp":
       var _cgpStates = ModuleService.getModuleDetailsCGPStates();
       $scope.cgpCollegeLevel = ModuleService.getModuleDetailsCGPCollegeLevel();
       var _cgpStatesOrdered = {};
       Object.keys(_cgpStates).sort().forEach(function (key) {
         _cgpStatesOrdered[key] = _cgpStates[key];
       });
       $scope.cgpStates = _cgpStatesOrdered;
       break;
     default:
   }
   // set up dropdown data
 }




 $scope.getIncludeStepOne = function () {
   var _tempString = "/content/html/partials/forms/" + _createAccountFor + "/create-account-" + _createAccountFor + "-step1.html";
   return _tempString;
 };

 $scope.getIncludeSteptwo = function () {
   var _tempString = "/content/html/partials/forms/" + _createAccountFor + "/create-account-" + _createAccountFor + "-step2.html";
   return _tempString;
 };

 $scope.getInclude = function () {
   var _tempString = "/content/html/partials/forms/" + _createAccountFor + "/create-account-" + _createAccountFor + "-step3.html";
   return _tempString;
 };

 $scope.submitStepOne = function (userdata) {
   // Validate User Email
   $scope.responsePending = true;
   var _userDataValidate = angular.copy(userdata);
   _userDataValidate.accountDetails.dateOfBirth = dobFilter(_userDataValidate.accountDetails.dateOfBirth);
   if (_createAccountFor === "emp") {
     _userDataValidate.accountDetails.canadianResident = false;
   }
   var _position = false;
   if ($scope.siteCode === 'frd' && $rootScope.frdPosition !== '') {
     _position = $rootScope.frdPosition;
   }
   apiFactory.userRegistrationValidation(_userDataValidate, _position)
     .then(function successRegistrationValidation(response) {
       $rootScope.hasIamAccount = response.data.hasIamAccount;
       $scope.setCreateAccountUserState();
       userValidSetandGo();
       delete $scope.responsePending;
     }, function errorCallback(response) {
       _userDataValidate = null;
       delete $scope.responsePending;
       $scope.serverError = response.data.errors;
     });

   function userValidSetandGo() {
     CreateAccountService.setUserDetails(userdata.accountDetails.firstName, userdata.accountDetails.lastName, userdata.email);
     if (_createAccountFor === "emp") {
       userdata.accountDetails.canadianResident = false;
     }
     if (_createAccountFor !== "emp" && $rootScope.createAnAccountUserType === "activeSessionExistingUser") {
       CreateAccountService.setAccountDetails(userdata);
       CreateAccountService.setCreateAccountStep("step3");
       $state.go("create-account.step-3")
     } else {
       CreateAccountService.setAccountDetails(userdata);
       CreateAccountService.setCreateAccountStep("step2");
       $state.go("create-account.step-2");
     }
   }
 };

 $scope.submitFRDStepOne = function (userdata) {
   // Validate User Email
   $scope.responsePending = true;
   var _userDataValidate = angular.copy(userdata);
   _userDataValidate.accountDetails.dateOfBirth = dobFilter(_userDataValidate.accountDetails.dateOfBirth);
   var _position = false;
   if ($rootScope.frdPosition !== '') {
     _position = $rootScope.frdPosition;
   }
   apiFactory.userRegistrationValidation(_userDataValidate, _position)
     .then(function successRegistrationValidation(response) {
       apiFactory.userRegistration(_userDataValidate, $rootScope.frdPosition)
         .then(function successRegistration(response) {
           var userEmail = $scope.email;
           $cookies.remove('createAccountDirect');
           DTMTrackerService.directCall('reg-complete');
           delete $scope.responsePending;
           delete $rootScope.hasIamAccount;
           delete $rootScope.cookie;
           if (response.data.loginFromRegister) {
             AuthenticationService.setAuthentication(response, userEmail);
             $state.go("view-auth");
           } else {
             ThirdPartyMessages.setMessage('registerNoAccount', '');
             $state.go('index');
           }
         }, function errorCallback(response) {
           $scope.serverError = response.data.errors;
           delete $scope.responsePending;
         });
     }, function errorCallback(response) {
       _userDataValidate = null;
       delete $scope.responsePending;
       $scope.serverError = response.data.errors;
     });
 };

/*
 $scope.submitStepTwo = function (securityDetails) {
   var body = {
     "username": $scope.user.email,
     "password": $scope.user.password
   }
   apiFactory.mobileLoginApi(body)
     .then(function successCallback(response) {
       CreateAccountService.setSecurityDetails(securityDetails);
       CreateAccountService.setCreateAccountStep("step3");
       $state.go("create-account.step-3");
     }, function errorCallback(response) {
       $scope.serverError = response.data.errors;
     });
 };
*/

 $scope.submitFRDStepTwo = function (securityDetails) {
   $scope.responsePending = true;
   CreateAccountService.setSecurityDetails(securityDetails);
   var _registrationObj = CreateAccountService.buildRegistrationObj(_createAccountFor);
   var body = {
     "username": $scope.user.email,
     "password": $scope.user.password
   }

   // apiFactory.mobileLoginApi(body)
   // .then(function successCallback(response) {
   //   CreateAccountService.setSecurityDetails(securityDetails);
   //   CreateAccountService.setCreateAccountStep("step3");
   //   $state.go("create-account.step-3");
   // }, function errorCallback(response) {
   //     $scope.serverError = response.data.errors;
   // });

   // Replaced on 7/28/2020 to go to Step 3
   apiFactory.mobileLoginApi(body)
     .then(function successCallback(response) {
       apiFactory.userRegistration(_registrationObj, $rootScope.frdPosition)
         .then(function successRegistration(response) {
           $cookies.remove('createAccountDirect');
           DTMTrackerService.directCall('reg-complete');
           delete $scope.responsePending;
           // $state.go("view-auth");
           if (response.data.loginFromRegister) {
             AuthenticationService.setAuthentication(response, userEmail);
             $state.go("view-auth");
           } else {
             ThirdPartyMessages.setMessage('registerNoAccount', '');
             $state.go('index');
           }
         }, function errorCallback(response) {
           $scope.serverError = response.data.errors;
           delete $scope.responsePending;
         });
     }, function errorCallback(response) {
       $scope.serverError = response.data.errors;
       delete $scope.responsePending;
     });
 };

 $scope.submitEMPStepTwo = function (securityDetails) {
   $scope.responsePending = true;
   CreateAccountService.setSecurityDetails(securityDetails);
   var body = {
     "username": $scope.user.email,
     "password": $scope.user.password
   }

   if ($scope.nicknameSelection === 'nickname') {
     CreateAccountService.updateNickNameAccountDetails(securityDetails.accountDetails);
   } else {
     securityDetails.accountDetails.nicknameFirstName = $scope.userFirstName;
     securityDetails.accountDetails.nicknameLastName = $scope.userLastName;
     CreateAccountService.updateNickNameAccountDetails(securityDetails.accountDetails)
   }

   var _registrationObj = CreateAccountService.buildRegistrationObj(_createAccountFor);

   apiFactory.mobileLoginApi(body)
     .then(function successCallback(response) {
       apiFactory.userRegistration(_registrationObj)
         .then(function successRegistration(response) {
           var userEmail = $scope.userEmailAddress;
           $cookies.remove('createAccountDirect');
           DTMTrackerService.directCall('reg-complete');
           delete $scope.responsePending;
           delete $rootScope.hasIamAccount;
           delete $rootScope.cookie;

           if (response.data.loginFromRegister) {
             AuthenticationService.setAuthentication(response, userEmail);
             $state.go("view-auth");
           } else {
             ThirdPartyMessages.setMessage('registerNoAccount', '');
             $state.go('index');
           }
         }, function errorCallback(response) {
           $scope.responsePending = false;
           $scope.serverError = response.data.errors;
         });
     }, function errorCallback(response) {
       $scope.responsePending = false;
       $scope.serverError = response.data.errors;
     });
 };

 $scope.submitStepThree = function (moduleDetails) {
   $scope.responsePending = true;

   var subsidiaryName;

   if (_createAccountFor === "sup") {
     // moduleDetails.moduleDetails.partnerClientCode.partnerId = $scope.modService.partnerID;
     if ($scope.modService.subsidiaries) {
       moduleDetails.moduleDetails.partnerClientCode.partnerId = $scope.modService.partnerID;
       subsidiaryName = $scope.subsidiary.selectedSubsidiary;
     } else {
       subsidiaryName = $scope.modService.partnerName
     }
     //Change for partner model updates 8/28/19
   }

   if (_createAccountFor === "sup" || _createAccountFor === "svppca") {
     moduleDetails.moduleDetails.partnerClientCode.subsidiaryName = subsidiaryName;

     //CreateAccountService.setModuleDetails(moduleDetails);

     var userEmail;

     if (!$scope.modService.subsidiaries) {
       moduleDetails.moduleDetails.partnerClientCode.partnerId = moduleDetails.moduleDetails.partnerClientCode.partnerCode;
       moduleDetails.moduleDetails.partnerClientCode.subsidiaryName = $scope.modService.partnerName;
     }
   }

   if ($scope.siteCode === 'mpp' || siteCode ==='frd' || siteCode === 'gmed') {
     userEmail = $scope.user.email;
   }

   CreateAccountService.setModuleDetails(moduleDetails);

   //$state.go("create-account.success");
   var _registrationObj = CreateAccountService.buildRegistrationObj(_createAccountFor);

   apiFactory.userRegistration(_registrationObj)
     .then(function successRegistration(response) {
       if (userEmail) {
         userEmail = userEmail;
       } else {
         userEmail = $scope.userEmailAddress;
       }
       $cookies.remove('createAccountDirect');
       DTMTrackerService.directCall('reg-complete');
       delete $scope.responsePending;
       delete $rootScope.hasIamAccount;
       delete $rootScope.cookie;
       if ($scope.siteCode === 'mpp' || $scope.siteCode === 'frd' || $scope.siteCode === 'gmed' || $scope.siteCode === 'ded') {
         AuthenticationService.setAuthentication(response, userEmail);
         $state.go("view-auth");
       } else {
         if (response.data.loginFromRegister) {
           AuthenticationService.setAuthentication(response, userEmail);
           $state.go("view-auth");
         } else {
           ThirdPartyMessages.setMessage('registerNoAccount', '');
           $state.go('index');
         }

       }
     }, function errorCallback(response) {
       $scope.responsePending = false;
       $scope.serverError = response.data.errors;
     });
 };

 // SUP & MPP - Reads User input and populates non-editable input and populates select box if it has subsidiaries.
 $scope.fetchdata = function () {
   $scope.modService = ModuleService;
   ModuleService.processPartnerAndSubsidiaryForCode($scope);
   // watch for Errors from API
   $scope.$watch('modService.serverError', function (hasServerError) {
     $scope.serverError = hasServerError;
   });
 };

 // $scope.checkNameRequired = function(){
 //     $scope.nicknameFirstNameRequiredError = $scope.user.accountDetails.nicknameFirstName === '' ?  true : false;
 //     $scope.nicknameLastNameRequiredError = $scope.user.accountDetails.nicknameLastName === '' ? true : false;
 // }

 $scope.checkPreferredNameSelection = function (nicknameSelection) {

   if (nicknameSelection === 'nickname') {
     $scope.nicknameFirstNameRequired = true;
     $scope.nicknameLastNameRequired = true;
     $scope.skipNameValidation = false;
     // if($scope.user.accountDetails.nicknameFirstName === '' || $scope.user.accountDetails.nicknameLastName === ''){

     //   $scope.nicknameFirstNameRequiredError = $scope.user.accountDetails.nicknameFirstName === '' ?  true : false;
     //   $scope.nicknameLastNameRequiredError = $scope.user.accountDetails.nicknameLastName === '' ? true : false;
     // }
   } else {
     $scope.nicknameFirstNameRequired = false;
     $scope.nicknameLastNameRequired = false;
     $scope.skipNameValidation = true;
   }
 }

 // CGP - gets selected State and populates next select box.
 $scope.fetchPartnerList = function () {
   $scope.modService = ModuleService;
   ModuleService.processPartnerListForState($scope);
   // watch for Errors from API
   $scope.$watch('modService.serverError', function (hasServerError) {
     $scope.serverError = hasServerError;
   });
 };

 $scope.goBackToStepOne = function () {
   CreateAccountService.unSetAccountDetails();
   CreateAccountService.setCreateAccountStep("step1");
   $state.go("create-account");
 };

 $scope.goBackToStepTwo = function () {
   CreateAccountService.setCreateAccountStep("step2");
   $state.go("create-account.step-2");
 };

 $scope.updateFrdPosition = function (frdPosition) {
   $rootScope.frdPosition = frdPosition.$viewValue;
 };

 $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
   if (!toState.name.includes('create-account')) {
     delete $rootScope.hasIamAccount;
     delete $rootScope.cookie;
     delete $rootScope.createAnAccountUserType;
     $cookies.remove('createAccountDirect');
     $cookies.remove('Registration');
   };
 });

};
